var $4e0c9a9a010e4598$exports = {};
$4e0c9a9a010e4598$exports = {
    "Clear search": `Zoekactie wissen`
};


export {$4e0c9a9a010e4598$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
